import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container } from '../../../../symphony';

import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { SlFlashMessage } from '../../../../shared/public/SlFlashMessage/SlFlashMessage';
import { SlDataService } from '../../services/sl-data.service';
import { SlDiscussContext } from '../../global-constants';
import { ActionType, RequestType } from '../../global-interface';
import { SlActions } from '../../services/ActionsService/sl-actions';

import s from './Notification.scss';

export function Notification() {
	useStyles(s);
	const { actions$ } = Container.take(SlDiscussContext, SlActions);
	const { notificationData$: notificationData } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['notificationData$'],
	);

	const closeHandler = () => {
		actions$.next({
			type: ActionType.TriggerNotificationVisibility,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<div className="discuss-notification">
			{notificationData ? (
				<SlFlashMessage
					data={{
						message: notificationData.message,
						type: notificationData.type,
					}}
					didClosed={closeHandler}
					onClose={closeHandler}
				/>
			) : null}
		</div>
	);
}
